export const environment = {
    production: false,
    apiUrl: 'https://api-lrtp-test.yaakadev.com'
};
